// extracted by mini-css-extract-plugin
module.exports = {"enter":"floating-object_enter__M0CcD","tooltip-enter":"floating-object_tooltip-enter__vsHpr"};